<template>
  <div class="content-box">

    <div class="sub-catalog">
        <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
                <el-breadcrumb-item>數據匯總</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="sub-line"></div>

    <div class="content">
      <div class="search-box">
        <div class="info-row">
          <div class="hg-class">
            <label>類別:</label>
            <el-select v-model="typeSel" id="classSel" class="classs-select"   >
              <el-option v-for="(item,index) in typelist" :key="index"  v-text="item.typecname" :value="item.typecname" ></el-option>
            </el-select>
          </div>
          <div class="hg-keyword">
            <label>商品名:</label>
            <el-input class="keyword-input" v-model="keyword"></el-input>
          </div>
        </div>
         
        <div class="info-row">
          <div class="hg-time">
            <label>時間:</label>
            <el-date-picker  value-format=”yyyy”  type="year" class="date" v-model="starttime"></el-date-picker>
            <label>至</label>
            <el-date-picker value-format=”yyyy”  type="year" class="date" v-model="endtime"></el-date-picker>
          </div>
          <div class="hg-addr">
            <label>港口名:</label>
            <el-select v-model="addrSel" id="addrSel" class="addr"  >
              <el-option v-for="(item,index) in addrlist" :key="index"  v-text="item.addrcname" :value="item.addrcname" ></el-option>
            </el-select>
          </div>
        </div>

        <div class="info-row" style="text-align:center">
          <div class="qd" >
            <el-button class="qd-btn"    @click="submitform" >確定</el-button>
          </div>
        </div>
      </div>



      <div class="data-box">
        <div class="data-menu">
          <div class="data-menu-left">
            <div>數據表單</div>
            <div class="l-img">
              <img src="../assets/icon/line.png">
              </div>
          </div>
          <div @click="exportExcel" class="data-menu-right">
            <div class="r-img">
              <img src="../assets/icon/download1.png">
              </div>
            <div class="download-excel">
              <a > excel下載</a>
            </div>
          </div>
        </div>

        <div class="tab-data">




          <template>
            <el-table class="table-class"
              v-loading="pictLoading"
              element-loading-text="數據正在加載中"
              element-loading-spinner="el-icon-loading"
              ref="multipleTable"
              :data="tableData"
              :row-style="tableRowStyle"
              :header-cell-style="tableHeaderColor"
              tooltip-effect="dark">
              <el-table-column
                prop="gxsd_port_cname"
                label="港口名稱"
                width="160">
              </el-table-column>
              <el-table-column
                prop="gxsd_year"
                label="年份"
                width="100">
              </el-table-column>
              <el-table-column
                prop="gxsd_my"
                label="進出口"
                width="150">
              </el-table-column>
              <el-table-column
                prop="gxsd_sp_name"
                label="商品名稱"
                width="400">
              </el-table-column>
              <el-table-column
                prop="gxsd_sl_tongji"
                label="進出口量"
                width="200">
              </el-table-column>
              <el-table-column
                prop="gxsd_money_tongji"
                label="進出口值"
                width="150">
              </el-table-column>
            </el-table>

            <div style="width:1150px">
              <div style="text-align: right;margin-top: 15px;">
              <el-pagination
                background
                :current-page="currrentpage"
                :page-sizes="[20, 50,200,500,1000,5000]"
                :page-size="pageSize"
                :data="tableData"
                :row-style="tableRowStyle"
                :header-cell-style="tableHeaderColor"
                layout="total,sizes,prev, pager, next"
                :total="totalcount"
                @current-change="current_change"
                @size-change="size_change">
              </el-pagination>
            </div>

            </div>


          </template>
        </div>

      </div>

      

      <div class="sjsc-container">
        <div class="sjsc">
          <span>數據生成</span>
          <img src="../assets/icon/line.png">
        </div>

        <template>
        <div class="sjsc-box" >
          <div class="sjsc-btns">
            <div @click="tabclick(0)" :style="tabcolor1" class="ewt-btn">二維圖</div>
            <div @click="tabclick(1)" :style="tabcolor2" class="gis-sc-btn">gis生成</div>
          </div>
          <div class="img-box" v-if="mytab==0">
            <div class="img-box-row">
              <div class="z-x">
                <span>X軸顯示：</span>
                <el-select v-model="z_x"  name="ew_zx" id="ew_zx">
                  <el-option value="時間">時間</el-option>
                  <el-option value="港口">港口</el-option>
                </el-select>
              </div>
              <div class="z-y">
                <span>Y軸顯示：</span>
                <el-select v-model="z_y"  name="ew_zy" id="ew_zy">
                  <el-option value="數量與價值統計">數量與價值統計</el-option>
                </el-select>
              </div>
              <div class="btn-sc">
                <div @click="clickGenerate">
                  生成
                </div>
              </div>
            </div>
            <div class="img-para">
              
              <div id="myChart" style="width: 1120px;height:880px;background-color:#f3f3f3; margin-left: 20px;"></div>
            </div>
          </div>
          <div class="img-box" v-if="mytab==1">
            <div class="img-box-row">
              <div class="z-x">
                <span>顯示區分：</span>
                <el-select v-model="mapviewSel"  name="gis_fs" id="gis_fs">
                  <el-option value="進出口值">進出口值</el-option>
                  <el-option value="進出口量">進出口量</el-option>
                </el-select>
              </div>
              <div class="z-y">
                <span>港口篩選：</span>
                <el-select v-model="classSel"  name="mapclassSel" id="mapclassSel">
                  <el-option value="全部">全部</el-option>
                  <el-option value="國內港口">國內港口</el-option>
                  <el-option value="進出口地">進出口地</el-option>
                </el-select>
              </div>
              <div class="btn-sc">
                <div @click="clickDrawMap">
                  生成
                </div>
              </div>
            </div>
            <div class="img-para">
              <div class="mymap" id="map" style="width: 1120px;height:880px;background-color:#f3f3f3;">

              </div>

              
            </div>
          </div>
        </div>
        </template>
      </div>



     




    </div>
  </div>
</template>





<script>

import FileSaver from '../lib/FileSaver.min.js';
import XLSX from 'xlsx'
import echarts from '../lib/echarts.min.js';
import china from  '../lib/china.json';
import world from  '../lib/countries.geo.json';
//import '../lib/china.js';
//import Chart from '../lib/Chart.min.js';
//import AMap from 'AMap';
//import Loca from 'Loca';
//import AMappanel from '../lib/amappanel.js';
//echarts.registerMap('china',china);
echarts.registerMap('world',world);

export default {
  //extents:Bar,
  name: "app",
  data() {
    return {
      pictLoading:false,
      object:{},
      datalist:[],//gis数据表
      chartdatalist:[],//统计表数据列表
      currrentpage:1,
      pageSize:20,
      totalcount:100,
      mytab:0,
      tabcolor1:"background-color: #c60828;color:#ffffff",
      tabcolor2:"background-color: #e5e2db;color:#c60828",
      tableData:[],//数据下载表数据列表
      classSel:'全部',//国内港口，国外港口
      addrSel:'',//港口地址
      typeSel:'',//进口还是出口？
      starttime:'',//起始时间
      endtime:'',//截止时间
      keyword:'',//货物名称关键词
      totaldata:'99999',
      z_x:"時間",
      z_y:"數量與價值統計",
      mapviewSel:"進出口值",
      //xlist: [ { "value": "时间", "nums": {"1840":"","":"1845","":""}},{ "value": "港口", "nums": {"南京":"","上海":"","大连":""}}],
      //ylist: [ { "exportcount": "出口量", "importcount": "进口量"}],
      classlist:[],
      addrlist: [ { "ID": 51, "addrcname": "全部", "addrename": "all" }, { "ID": 50, "addrcname": "國內港口", "addrename": "CHINA" }, 
      { "ID": 49, "addrcname": "進出口地", "addrename": "othercountrys" },{ "ID": 48, "addrcname": "思茅", "addrename": "SZEMAO" }, 
      { "ID": 47, "addrcname": "蒙自", "addrename": "MENGTSZ" }, { "ID": 46, "addrcname": "三水", "addrename": "SAMSHUI" }, 
      { "ID": 45, "addrcname": "三都澳", "addrename": "SANTUAO" }, { "ID": 44, "addrcname": "杭州", "addrename": "HANGCHOW" }, 
      { "ID": 43, "addrcname": "蘇州", "addrename": "SOOCHOW" }, { "ID": 42, "addrcname": "蕪湖", "addrename": "WUHU" }, 
      { "ID": 41, "addrcname": "嶽州", "addrename": "YOCHOW" }, { "ID": 40, "addrcname": "長沙", "addrename": "CHANGSHA" }, 
      { "ID": 39, "addrcname": "沙市", "addrename": "SHASI" }, { "ID": 38, "addrcname": "萬縣", "addrename": "WANHSIEN" }, 
      { "ID": 37, "addrcname": "威海衛", "addrename": "WEIHAIWEI" }, { "ID": 36, "addrcname": "大連", "addrename": "DAIREN" }, 
      { "ID": 35, "addrcname": "安東", "addrename": "ANTUNG" }, { "ID": 34, "addrcname": "龍井村", "addrename": "LUNGCHINGTSUN" }, 
      { "ID": 33, "addrcname": "琿春", "addrename": "HUNCHUN" }, { "ID": 32, "addrcname": "哈爾濱", "addrename": "HARBIN" }, 
      { "ID": 31, "addrcname": "新疆", "addrename": "SINKIANG" }, { "ID": 30, "addrcname": "騰越", "addrename": "TENGCHUNG" }, 
      { "ID": 29, "addrcname": "昆明", "addrename": "KUNMING" }, { "ID": 28, "addrcname": "龍州", "addrename": "LUNGCHOW" }, 
      { "ID": 27, "addrcname": "北海", "addrename": "PAKHOI" }, { "ID": 26, "addrcname": "雷州", "addrename": "LUICHOW" }, 
      { "ID": 25, "addrcname": "南寧", "addrename": "NANNING" }, { "ID": 24, "addrcname": "梧州", "addrename": "WUCHOW" }, 
      { "ID": 23, "addrcname": "江門", "addrename": "KONGMOON" }, { "ID": 22, "addrcname": "拱北", "addrename": "LAPPA" }, 
      { "ID": 21, "addrcname": "九龍", "addrename": "KOWLOON" }, { "ID": 20, "addrcname": "璦琿", "addrename": "AIGUN" },
       { "ID": 19, "addrcname": "廣州", "addrename": "CANTON" }, { "ID": 18, "addrcname": "汕頭", "addrename": "SWATOW" }, 
       { "ID": 17, "addrcname": "打狗（臺南）", "addrename": "TAINAN" }, { "ID": 16, "addrcname": "臺北", "addrename": "TAIPEH" }, 
       { "ID": 15, "addrcname": "廈門", "addrename": "AMOY" }, { "ID": 14, "addrcname": "福州", "addrename": "FOOCHOW" }, 
       { "ID": 13, "addrcname": "溫州", "addrename": "WENCHOW" }, { "ID": 12, "addrcname": "寧波", "addrename": "NINGPO" }, 
       { "ID": 11, "addrcname": "上海", "addrename": "SHANGHAI" }, { "ID": 10, "addrcname": "南京", "addrename": "NANKING" }, 
       { "ID": 9, "addrcname": "漢口", "addrename": "HANKOW" }, { "ID": 8, "addrcname": "重慶", "addrename": "CHUNGKING" }, 
       { "ID": 7, "addrcname": "膠州（青島）", "addrename": "KIAOCHOW" }, { "ID": 6, "addrcname": " 芝罘", "addrename": "CHEFOO" }, 
       { "ID": 5, "addrcname": "天津", "addrename": "TIENTSIN" }, { "ID": 4, "addrcname": "秦皇島", "addrename": "CHINWANGTAO" }, 
       { "ID": 3, "addrcname": "牛莊", "addrename": "NEWCHWANG" }, { "ID": 2, "addrcname": "沈陽", "addrename": "SHENYANG" },
        { "ID": 1, "addrcname": "安東", "addrename": "ANTUNG" } ],
      typelist: [ { "ID": 0, "typecname": "全部", "typeename": "all" },{ "ID": 1, "typecname": "進口", "typeename": "import" },{ "ID": 2, "typecname": "出口", "typeename": "export" }],
    };
  },
  mounted(){
    //this.drawMap();
    //this.generate();
    //this.clickDrawMap();
    //this.clickGenerate();
    
  },
  methods: {


    getJson() {
      if(this.starttime.toString().length>2){
        this.object['starttime'] = this.starttime.toString().slice(1,this.starttime.toString().length-1);///统计起始时间
      }
      if(this.endtime.toString().length>2){
        this.object['endtime'] = this.endtime.toString().slice(1,this.endtime.toString().length-1);///统计截止时间
      }
      this.object['addrSel'] =this.addrSel.toString();//统计港口名
      this.object['keyword'] =this.keyword.toString();//统计货物名称关键字

      this.object['classSel'] =this.classSel.toString();//商品分类
      this.object['typeSel'] =this.typeSel.toString();//进口还是出口？

      this.object['currentPage']=this.currrentpage;
      this.object['pageSize']=this.pageSize;

      this.object['z_x']=this.z_x;
      this.object['z_y']=this.z_y;
      this.object['mapviewSel']=this.mapviewSel;

      //z_x:"时间",
      //z_y:"数量与价值统计",
      //mapviewSel:"分布显示",

      let myjson = JSON.stringify(this.object);
      //alert(myjson);
      return myjson;    
    },
    //点击生成图形
    clickGenerate(){
      let json = this.getJson();
      this.$http
        .post(`${this.$store.state.baseurl}/api/tongji_chart`,json)
          .then((res) => {
            let json=JSON.parse(res.data);
            this.chartdatalist=json.data;
            //alert("获取图形数据："+res.data);
            this.generate();
          });
      
    },
    //点击绘制地图
    clickDrawMap(){
      let json = this.getJson();
      this.$http
        .post(`${this.$store.state.baseurl}/api/tongji_map`,json)
          .then((res) => {
            let json=JSON.parse(res.data);
            this.datalist=json.data;
            this.drawMap();
          });
      
    },





    current_change(val){
          this.currrentpage=val;
          var rcode=window.sessionStorage.getItem('hgcode');
          if(rcode!=null){
            this.submitform();
          }
          else{
            this.$message('请登錄！');
          }
          //this.submitform();
          //this.retrieval();
        },
        size_change(val){
          this.pageSize=val;
          var rcode=window.sessionStorage.getItem('hgcode');
          if(rcode!=null){
            this.submitform();
          }
          else{
            this.$message('请登錄！');
          }
          //this.submitform();
          //this.retrieval();

          //this.submitform();
        },
     //生成gis地图
    drawMap(){
      const data=this.datalist;
      return;

      
    const geoCoordMap = {
      璦琿:[127.50048,50.2521],
      九龍:[114.18895,22.304368424633775],
      澳門:[113.54913,22.19875],
      三姓:[129.56859,46.32489],
      大東溝:[124.15209,39.86172],
      龍州:[106.85455,22.34262],
      香港:[114.16546,22.27534],
      思茅:[100.97692,22.78684],
      哈爾濱:[126.95717,45.54774],
      拱門:[113.29673,22.20907],
      南寧:[108.27331,22.78121],
      安東:[124.39582,40.13673],
      滿洲裏:[117.37836,49.59655],
      嶽州:[113.00651,29.46135],
      騰越:[98.49097,25.02053],
      沙市:[112.25494,30.31098],
      溫州:[121.1572,27.83616],
      三都澳:[119.52623,26.66022],
      北海:[109.1175,21.47525],
      蘇州:[120.63132,31.30227],
      江門:[113.11103,22.56028],
      綏芬河:[131.15012,44.4132],
      長沙:[112.98626,28.25591],
      三水:[112.896581,23.155737],
      宜昌:[111.43471,30.5307],
      瓊州:[110.32941,20.02971],
      南京:[118.8921,31.32751],
      秦王島:[119.48458,39.83507],
      梧州:[111.27466,23.48555],
      蒙自:[103.3756,23.36422],
      大連:[121.5255,38.95223],
      廈門:[118.03394,24.48405],
      杭州:[120.21201,30.2084],
      拱北:[113.56062,22.22157],
      福州:[119.27345,26.04769],
      寧波:[121.84431,29.89889],
      膠州:[120.03354,36.26445],
      蕪湖:[118.38548,31.34072],
      之罘:[121.27077,37.54836],
      九江:[116.00144,29.7055],
      重慶:[106.54041,29.40268],
      鎮江:[119.43396,32.13188],
      汕頭:[116.4331,23.25029],
      牛莊:[122.54256,40.95499],
      廣州:[113.27324,23.15792],
      天津:[117.30983,39.71755],
      漢口:[114.02919,30.58203],
      上海:[121.48941,31.40527],

      意大利:[12.50523,41.89442],
      瑙威:[10.75373,59.91476],
      新加坡等地:[103.88629,1.32065],
      南美洲:[-47.38647,-23.57343],
      葡國:[0.46143,40.75328],
      瑞士:[8.54434,47.38089],
      瑞典:[18.00007,59.32093],
      南非洲:[18.5602,-33.92798],
      墨國及中美洲:[-102.88422,20.22612],
      丹國:[13.35508,55.6892],
      菲律滨岛:[120.92171,14.56331],
      日国:[139.74266,35.72422],
      澳洲紐絲綸等處:[150.01556,-33.18813],
      暹羅:[100.61108,13.79007],
      義國:[14.90776,41.16418],
      土波埃等處:[36.23222,37.93337],
      俄國黑龍江各口:[135.07759,48.55298],
      奧國:[13.87642,47.66909],
      和國:[4.96359,52.35443],
      坎拿大:[-122.92517,52.08626],
      朝鮮:[126.03344,38.98877],
      美國檀香山:[-158.16492,21.38147],
      俄國由陸路:[122.11304,59.25465],
      安南:[106.45889,20.40127],
      爪哇等處:[106.94092,-6.79554],
      俄國歐洲各口:[37.13379,55.9738],
      新嘉坡等處:[102.98629,1.42065],
      比國:[4.36724,50.84649],
      法國:[2.33253,48.86833],
      俄國太平洋各口:[131.91765,43.12504],
      德國:[13.3786,52.53293],
      歐洲大陸:[9.8877,49.95122],
      印度:[78.01941,22.59373],
      美國及檀香山:[-77.19733,38.92096],
      英國:[0.15381,51.50874],
      日本:[135.41473,34.85889],
      
    };
    var convertData;
    if(this.mapviewSel=='進出口值'){
          //mapv=data[i].gxsd_money_tongji;
          convertData= function (data) {
          var res = [];
          //alert(this.mapviewSel);
          for (var i = 0; i < data.length; i++) {
            var geoCoord = geoCoordMap[data[i].gxsd_port_cname];
            var mapv;
            
            
            if (geoCoord) {
              res.push({
                name: data[i].gxsd_port_cname,
                value: geoCoord.concat(data[i].gxsd_money_tongji)
              });
            }
          }
          //alert(res);
          return res;
        };
    }else{
          //mapv=data[i].gxsd_sl_tongji;
          convertData= function (data) {
          var res = [];
          //alert(this.mapviewSel);
          for (var i = 0; i < data.length; i++) {
            var geoCoord = geoCoordMap[data[i].gxsd_port_cname];
            var mapv;
            
            
            if (geoCoord) {
              res.push({
                name: data[i].gxsd_port_cname,
                value: geoCoord.concat(data[i].gxsd_sl_tongji)
              });
            }
          }
          //alert(res);
          return res;
        };
    }

    var option;
    if(this.mapviewSel=='進出口值'){
      option= {
        backgroundColor: '#f3f3f3',
        title: {
          text: '各港口進出口值',
          subtext: '1902-1931',
          sublink: '',
          left: 'center',
          textStyle: {
            color: '#333'
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          top: 'bottom',
          left: 'right',
          data: [''],
          textStyle: {
            color: '#fff'
          }
        },
        geo: {
          map: 'world',
          roam: true,
          label: {
            show: false
          },
          itemStyle: {
            areaColor: '#333',
            borderColor: '#333'
          },
          emphasis: {
            itemStyle: {
              areaColor: '#333'
            }
          }
        },
        series: [
          {
            name: '進出口（單位關平兩）',
            type: 'scatter',
            coordinateSystem: 'geo',
            data: convertData(data),
            encode: {
              value: 2
            },
            symbolSize: function (val) {
              //return val[2] / 10;
              return 10;
            },
            label: {
              formatter: '{b}',
              position: 'right',
              show: false
            },
            itemStyle: {
              color: '#ddb926'
            },
            emphasis: {
              label: {
                show: true
              }
            }
          },
          
        ]
      };
    }else{
      option= {
        backgroundColor: '#f3f3f3',
        title: {
          text: '各港口進出口量',
          subtext: '1902-1931',
          sublink: '',
          left: 'center',
          textStyle: {
            color: '#333'
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          top: 'bottom',
          left: 'right',
          data: [''],
          textStyle: {
            color: '#fff'
          }
        },
        geo: {
          map: 'world',
          roam: true,
          label: {
            show: false
          },
          itemStyle: {
            areaColor: '#323c48',
            borderColor: '#111'
          },
          emphasis: {
            itemStyle: {
              areaColor: '#a2333d'
            }
          }
        },
        series: [
          {
            name: '進出口(單位)',
            type: 'scatter',
            coordinateSystem: 'geo',
            data: convertData(data),
            encode: {
              value: 2
            },
            symbolSize: function (val) {
              //return val[2] / 10;
              return 10;
            },
            label: {
              formatter: '{b}',
              position: 'right',
              show: false
            },
            itemStyle: {
              color: '#ddb926'
            },
            emphasis: {
              label: {
                show: true
              }
            }
          },
          
        ]
      };
    }
     
     



    var mymap = echarts.init(document.getElementById('map'));

    // 使用刚指定的配置项和数据显示图表。
    mymap.setOption(option);
            
    },



    //导出excel
    exportExcel(){
      var wb = XLSX.utils.table_to_book(document.querySelector('.table-class'))
      /* get binary string as output */
      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'sheetjs.xlsx')
      } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
      return wbout;
    },
    //生成二维图
    generate(){
       const data=this.chartdatalist;

       console.log(data);

       var myChart = echarts.init(document.getElementById('myChart'));
 
      // 指定图表的配置项和数据
      var option = {
              legend: {},
              tooltip: {},
              dataset: {
                  source: data
              },
              xAxis: [
                  {type: 'category', gridIndex: 0},
                  {type: 'category', gridIndex: 1}
              ],
              yAxis: [
                  {gridIndex: 0},
                  {gridIndex: 1}
              ],
              grid: [
                  {bottom: '55%'},
                  {top: '55%'}
              ],
              series: [
                  // 这几个系列会在第一个直角坐标系中，每个系列对应到 dataset 的每一行。
                  {type: 'line', seriesLayoutBy: 'row'},
                  {type: 'line', seriesLayoutBy: 'row'},
                  // 这几个系列会在第二个直角坐标系中，每个系列对应到 dataset 的每一列。
                  {type: 'bar', xAxisIndex: 1, yAxisIndex: 1},
                  {type: 'bar', xAxisIndex: 1, yAxisIndex: 1}
              ]
          }

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    tabclick(a){
      this.mytab=a;
      if(a==0){
        this.tabcolor1="background-color: #c60828;color:#ffffff";
        this.tabcolor2="background-color: #e5e2db;color:#c60828";
        this.clickGenerate();
        //this.generate();
      }
      if(a==1){
        this.tabcolor1="background-color: #e5e2db ;color:#c60828";
        this.tabcolor2="background-color: #c60828;color:#ffffff";
        this.$message('请登錄！');
        //this.clickDrawMap();
        //this.drawMap();
      }
    },
    loadmap(){
      //const map=new AMap("mymap",{zoom:9});
    },
    //设置表格行的样式
   tableRowStyle({row,rowIndex}){
     let st;
     if(rowIndex%2==1){
       st={
         'background-color':'#f0f0f0',
       };

     }
     return st;
     },
      //设置表头行的样式
     tableHeaderColor({row,column,rowIndex,columnIndex}){
        return 'background-color:#d4c9bc;color:#9a7455;font-wight:500;font-size:16px;text-align:center;height: 50px';
      },

    submitform(){
      this.pictLoading=true;

      let json = this.getJson();
      this.$http
        .post(`${this.$store.state.baseurl}/api/tongji_sheet`,json)
          .then((res) => {
            let json=JSON.parse(res.data);
            this.tableData=json.data;
            //console.log(json);
            this.totalcount=json.dataSize;
            if(this.mytab==0){
              this.clickGenerate();
              //this.generate();

            }
            if(this.mytab==1){
              this.clickDrawMap();
             //this.drawMap();
            }
            this.pictLoading=false;
          });


    },
    
    getTow(){

      //alert('333');

    },
    getTime(date) {
      // let date = new Date()
      // return dateFormat("YYYY-mm", date)
      return date;
    },
  },
  created() {
    //获取当前条目ID号
    let id = this.$route.params.id;
    let searchtxt="海";
    this.$http
      .get(`${this.$store.state.baseurl}/api/hgdatacount/getclasslist?id=0&p=s&l=q`)
      .then((res) => {
        const json = res.data;
        classlist = JSON.parse(json);

      });

      this.$http
      .get(`${this.$store.state.baseurl}/api/hgdatacount/getaddrlist?id=0`)
      .then((res) => {
        const json = res.data;
        addrlist = JSON.parse(json);
      });

      this.submitform();
        

    //this.drawMap();

  },
};
</script>


<style scoped lang="scss">
.sjsc-container{
  margin-bottom: 15px;
  .sjsc{
    text-align: left;
    span{
      font-size: 18px;
    }
    img{
      width: 400px;
      height: 20px;
    }
  }
  .sjsc-box{
    margin: 20px 20px 0px 20px;
    text-align: left;
    .sjsc-btns{
      display: flex;
      flex-direction: row;
      justify-content: start;
      flex-wrap: wrap;
      .ewt-btn{
        border-radius: 5px 5px 0px 0px;
        padding: 10px 30px 0px 30px;
        background-color: #c60828;
        width: 50px;
        height: 20px;
        color:#ffffff;
        font-size: 14px;
        cursor:pointer;
      }
      .gis-sc-btn{
        border-radius: 5px 5px 0px 0px;
        padding: 10px 30px 0px 30px;
        background-color: #e5e2db;
        width: 50px;
        height: 20px;
        color: #c60828;
        font-size: 14px;
        cursor:pointer;
      }
    }
  }
  .img-box{
    background-color: #ffffff;
    width: 1160px;
    height: 1000px;
    .img-box-row{
      padding: 30px;
      display: flex;
      flex-direction: row;
      justify-content: start;
      flex-wrap: wrap;
      .z-x{
        display: flex;
        flex-direction: row;
        justify-content: start;
        flex-wrap: wrap;
        span{
          width: 80px;
          height: 25px;
          margin-top: 5px;
        }
        select{
          width: 250px;
          height: 35px;
          margin-left: 10px;
        }
      }
      .z-y{
        margin-left: 100px;
        margin-right: 300px;
        display: flex;
        flex-direction: row;
        justify-content: start;
        flex-wrap: wrap;
        span{
          width: 80px;
          height: 25px;
          margin-top: 5px;
        }
        select{
          width: 250px;
          height: 35px;
          margin-left: 10px;
        }
      }
      .btn-sc{
        width: 80px;
        height: 35px;
        
        div{
          width: 50px;
          height:20px;
          background-color: #c60828;
          border-radius: 5px;
          color: #ffffff;
          padding: 10px 30px 10px 40px;
        }
      }
    }
    .img-para{
      width: 1120px;
      height: 880px;
      
      
      canvas{
        background-color: #cec0b2;
        margin-left: 20px;
        margin-right: 20px;
      }
    }
  }
}


.content-box {
  display: flex;
  flex-direction: column;
  min-height:600px;
  width: 100%;
  background-color: #e5e2db;
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}
.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
}
.mymap {
  margin-left: 20px;
  width: 1120px;
  height: 900px;
}

.sub-catalog{
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  font-size: 14px;
  color: #666666;
  padding-top: 14px;
  padding-bottom: 14px;
  
}
.sub-line{
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}

.search-box{
  .info-row{
    margin-top: 25px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    flex-wrap: wrap;
    font-size: 14px;
    .qd{
      margin:0 auto;
      display: block;
      .qd-btn{
        width: 160px;
        height: 40px;
        color: #ffffff;
        background-color: #c60828 ;
        
      }
    }
    .hg-class{
      margin-left: 50px;
      margin-right:100px;
      width: 420px;
      text-align: left;
      label{
        color: #666666;
        padding-left: 10px;
        padding-right: 10px;
      }
      .classs-select{
        width:340px;
        height: 40px;
      }

    }
    .hg-keyword{
      margin-left: 150px;
      margin-right:50px;
      width: 420px;
      text-align: left;
      label{
        color: #666666;
        padding-left: 10px;
        padding-right: 10px;
      }
      .keyword-input{
        width:335px;
        height: 35px;

      }

    }
    .hg-time{
      margin-left: 50px;
      margin-right:100px;
      width: 420px;
      text-align: left;
      label{
        color: #666666;
        padding-left: 10px;
        padding-right: 10px;
      }
      .date{
        width:154px;
        height: 40px;
      }

    }
    .hg-addr{
      margin-left: 150px;
      margin-right: 50px;
      width: 420px;
      text-align: left;
      label{
        color: #666666;
        padding-left: 10px;
        padding-right: 10px;
      }
      .addr{
        width:335px;
        height: 40px;

      }

    }
    
  }
}

.data-box{
  .data-menu{
    display: flex;
    flex-direction: row;
    justify-content: start;
    flex-wrap: wrap;
    margin: 15px 30px 15px 30px;
    .data-menu-left{
      display: flex;
      flex-direction: row;
      justify-content: start;
      flex-wrap: wrap;
      width: 1000px;
      .l-img img{
        width: 400px;
        height: 25px;
      }

    }
    .data-menu-right{
      display: flex;
      flex-direction: row;
      justify-content: start;
      flex-wrap: wrap;
      width: 150px;
      .r-img img{
        width:25px;
        height: 25px;
      }
      .download-excel a{
        text-decoration: none;
        font-size: 14px;
        color: #906442;

      }
    }
  }
  .tab-data{
    padding: 25px 0px;
    margin-left: 20px;
    .table-class{
      margin-left: 15px auto;
      width: 1160px;
    }
  }
}





</style>